import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getDisabledCentersRequest: ['response'],
    getDisabledCentersSuccess: ['response', 'loading'],
    getDisabledCentersFailure: ['error'],
})

export const getDisabledCentersTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getDisabledCentersSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getDisabledCentersFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getDisabledCentersRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_DISABLED_CENTERS_REQUEST]: getDisabledCentersRequest,
    [Types.GET_DISABLED_CENTERS_SUCCESS]: getDisabledCentersSuccess,
    [Types.GET_DISABLED_CENTERS_FAILURE]: getDisabledCentersFailure,
})
